export default __webpack_public_path__ + "static/media/opensans-extrabold-webfont.63fe2171.woff2";